<script setup lang="ts">
import { watch, ref } from 'vue';
import Dialog from 'primevue/dialog';
import Cropper from 'cropperjs';
import 'cropperjs/dist/cropper.css';
import { ButtonType, CustomButton } from '@/components';
import { useUserManagementStore } from '@/stores/userManagement';

defineProps({
  visible: {
    type: Boolean,
    required: true
  }
});

const userManagementStore = useUserManagementStore();

const initial = ref(0);
let cropper: Cropper | null = null;

const emits = defineEmits(['onClose']);

const closeDialog = async () => {
  emits('onClose');
  if (cropper) {
    cropper.destroy();
    cropper = null;
  }
  await userManagementStore.getUserAvatar();
};

const initializeCropper = () => {
  if (!userManagementStore.avatar) {
    return;
  }
  const image = document.getElementById('cropImage') as HTMLImageElement;
  if (image && !cropper) {
    image.src = 'data:image/jpeg;base64,' + userManagementStore.avatar;
    cropper = new Cropper(image, {
      aspectRatio: 1,
      viewMode: 1
    });
  }
};

watch(() => userManagementStore.avatar, () => {
  if (initial.value === 0) {
    initial.value += 1;
    return;
  }
  initializeCropper();
});

const cropImage = async () => {
  if (cropper) {
    const canvas = cropper.getCroppedCanvas();
    const croppedImage = canvas.toDataURL('image/jpeg');
    initial.value = 0;
    userManagementStore.avatar = croppedImage.split('base64,')[1];
    await userManagementStore.patchUserAvatar();
    closeDialog();
  }
};
</script>

<template>
  <Dialog :visible="visible"
    modal
    header=""
    class="dialog"
    style="width: 400px;"
    :closeOnEscape="true"
    :draggable="false"
    @update:visible="closeDialog">
    <div>
      <img id="cropImage" />
    </div>
      <div class="buttons">
        <CustomButton text="Save" :type="ButtonType.POSITIVE" @onClick="cropImage" />
        <CustomButton text="Cancel" @onClick="closeDialog" />
      </div>
  </Dialog>
</template>

<style scoped lang="scss">
img {
  display: block;
  max-width: 100%;
}

.buttons {
  margin-top: 10px;
  display: flex;
  justify-content: center;
}

:deep(button) {
  margin: 5px;
}
</style>
